// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM10 9H6V11H7V15H9V11H10V9ZM18 9H14V11H15V15H17V11H18V9ZM13 16V13H11V16H13Z"}}]};

const CryLoudlyFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cry-loudly-filled',
    ref,
    icon: element,
  },
));

CryLoudlyFilledIcon.displayName = 'CryLoudlyFilledIcon';

export default CryLoudlyFilledIcon;
